import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import client from "../api/client";
import { getApiErrorMessage } from "../utils";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("token") || "";

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!token) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-sm rounded-xl border border-gray-200 bg-white p-6 shadow-sm text-center">
          <p className="text-sm text-gray-600">Invalid or missing reset token.</p>
          <Link to="/login" className="mt-4 inline-block text-sm text-blue-600 hover:underline">Back to sign in</Link>
        </div>
      </div>
    );
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters");
      return;
    }
    setLoading(true);
    try {
      await client.post("/auth/reset-password", { token, new_password: newPassword });
      navigate("/login?reset=1");
    } catch (err) {
      setError(getApiErrorMessage(err, "Reset link is invalid or has expired"));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-xl bg-[#1D345F] px-5 py-6 shadow-lg sm:p-8">
        <h1 className="mb-6 text-left text-2xl font-semibold text-white">Set new password</h1>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-sm font-medium text-white">New password</label>
            <input
              type="password"
              required
              minLength={8}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-black bg-white"
            />
          </div>
          <div>
            <label className="mb-1 block text-sm font-medium text-white">Confirm new password</label>
            <input
              type="password"
              required
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500 text-black bg-white"
            />
          </div>
          {error && <p className="text-sm text-red-600">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-lg bg-[#45a164] border-2 border-[#45a164] px-4 py-2 text-sm font-medium text-white hover:border-white disabled:opacity-50"
          >
            {loading ? "Saving..." : "Set new password"}
          </button>
        </form>
        <p className="mt-4 text-left text-sm text-gray-500">
          <Link to="/login" className="text-white underline">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
